'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    Osano?: {
      cm?: {
        render: () => void;
        showDrawer: () => void;
      };
    };
  }
}

// osano.js loads with data-osano-load-mode="event", so its UI waits for this call. Osano inserts
// its UI at the start of <body>, which breaks hydration if it lands before React has hydrated.
export const OsanoUiRenderer = () => {
  useEffect(() => {
    window.Osano?.cm?.render();
  }, []);

  return null;
};
